import { BaseEntity } from './BaseEntity';

export interface RoleModel extends BaseEntity {
 // Id: number;
  RoleName: string;
  Notes: string;
};

export class RoleFunctionModel implements BaseEntity {
  Id: number;
  RoleId : number;
  PageId : number;
  FunctionId : number;

  constructor(RoleId, PageId, FunctionId) {
    this.RoleId = RoleId;
    this.PageId = PageId;
    this.FunctionId = FunctionId;
  }
};

export class RequestRoleFunctionModel<T> {
  Id: number;  
  RoleFunction : RoleFunctionModel[];  

  constructor(Id, RoleFunction) {
    this.Id = Id;
    this.RoleFunction = RoleFunction;
  }
};